import {takeLatest, takeEvery, call, put} from 'redux-saga/effects';
import { push } from 'connected-react-router';

import {
    REQUEST_NEWS,
    REQUEST_NEWS_SUCCESS,
    REQUEST_NEWS_ERROR,
    EDIT_NEWS,
    EDIT_NEWS_SUCCESS,
    EDIT_NEWS_ERROR,
    GET_SINGLE_NEWS,
    GET_SINGLE_NEWS_SUCCESS,
    GET_SINGLE_NEWS_ERROR,
    GET_MOST_READ_NEWS_BY_CATEGORY,
    GET_MOST_READ_NEWS_BY_CATEGORY_SUCCESS,
    GET_MOST_READ_NEWS_BY_CATEGORY_ERROR,
    MOST_READ_NEWS_ITEMS_PER_PAGE,
    DELETE_NEWS,
    DELETE_NEWS_SUCCESS,
    DELETE_NEWS_ERROR,
    NEWS_ITEMS_PER_PAGE,
    MOST_READ_NEWS_SUCCESS,
    MOST_READ_NEWS,
    MOST_READ_NEWS_ERROR

} from './constants';

import {getNews, createNewsService, getSingleNews, editNewsService, getMostReadNewsByCategory, deleteNewsService, getMostReadNews} from './service';

// Import Notifications and Store Service
import {setNotificationSuccess, setNotificationError} from '../Notifications/actions';
import StoreService from '../../utils/StoreService'
import intl from '../../intl';
import generalMessages from '../generalMessages';
import {getMostReadNewsByCategory as getMostReadNewsByCategoryAction, modalAction, requestNews} from './actions';
import { AxiosError, AxiosResponse } from 'axios';
import routes from '../../config/routes';

function* getNewsFlow(action: any) {

  const {category, page, search, admin} = action;

  try {
    const response: AxiosResponse = yield call(getNews, page, NEWS_ITEMS_PER_PAGE, category, search, admin);
    yield put({ type : REQUEST_NEWS_SUCCESS, response})  
  } catch(error) {
      yield put({type: REQUEST_NEWS_ERROR, error})
  }
}

function* mostReadNewsFlow(action: any) {
  const {page} = action;
  try {
    const response: AxiosResponse = yield call(getMostReadNews, page, MOST_READ_NEWS_ITEMS_PER_PAGE);
    yield put({type: MOST_READ_NEWS_SUCCESS, response});

  } catch(error) {
      yield put({type: MOST_READ_NEWS_ERROR, error})
  }
}

function* editNews(action: any) {

  const {data} = action;
  const {id, assigned_to, task_id, task_type} = data;
  
  try {
    const response: AxiosResponse = yield id ? call(editNewsService, data, id) : call(createNewsService, data);

    yield put({type: EDIT_NEWS_SUCCESS, response});

    if(assigned_to && task_id) {
      yield put(push(`${routes.DashboardPage}/tasks/${task_type}`));
    }

    StoreService.dispatch(setNotificationSuccess(intl.formatMessage(id ? generalMessages.EditNewsNotif : generalMessages.CreateNewsNotif)));

    if(!assigned_to && !task_id) { 
      StoreService.dispatch(modalAction(true));
    }


  } catch (error) {

    if(error) {
      const {response} = error as AxiosError | any;

      const {data} = response;

      if(response && response.status === 422) {
        data?.errors?.slug ? StoreService.dispatch(setNotificationError("Uneo si link koji već postoji.")) : StoreService.dispatch(setNotificationError(intl.formatMessage(generalMessages.SomethingNotRight)));
      } else {
        StoreService.dispatch(setNotificationError(intl.formatMessage(generalMessages.SomethingNotRight)))
      }
    }
    yield put({type: EDIT_NEWS_ERROR, error})
  }
}

function* getDetailedNews(action: any) {

  const {id, admin} = action;

  try {
    const response: AxiosResponse = yield call(getSingleNews, id, admin);
    yield put({type: GET_SINGLE_NEWS_SUCCESS, response})
    StoreService.dispatch(getMostReadNewsByCategoryAction(response.data.category, response.data.unique_id, 1));

  } catch (error) {
    yield put({type: GET_SINGLE_NEWS_ERROR, error})
  }
}

// Get Most Read News By Category
function* getMostReadNewsCategory(action: any) {

  const {category, unique_id, page} = action;

  try {
    const response: AxiosResponse = yield call(getMostReadNewsByCategory, category, unique_id, page, MOST_READ_NEWS_ITEMS_PER_PAGE);
    yield put({type: GET_MOST_READ_NEWS_BY_CATEGORY_SUCCESS, response})
  } catch (error) {
    yield put({type: GET_MOST_READ_NEWS_BY_CATEGORY_ERROR, error})
  }
}

function* deleteNewsFlow(action: any) {

  const {id, page} = action;

  try {
    const response: AxiosResponse = yield call(deleteNewsService, id);
    yield put({type: DELETE_NEWS_SUCCESS, response})
    StoreService.dispatch(requestNews('', page, '', true));
  } catch (error) {
    yield put({type: DELETE_NEWS_ERROR, error})
  }
}

// Most Read News
// function* mostReadNewsFlow(action: any) {
//   const {page} = action;
//     try {
//       const response: AxiosResponse = yield call(getMostReadNews, page, MOST_READ_NEWS_ITEMS_PER_PAGE);
//       yield put({type: MOST_READ_NEWS_SUCCESS, response});
//     } catch(error) {
//         yield put({type: MOST_READ_NEWS_ERROR, error}) ;
//     }
// }


export default function* newsSaga() {
  
    yield takeEvery(REQUEST_NEWS, getNewsFlow);
    yield takeEvery(EDIT_NEWS, editNews);
    yield takeLatest(GET_SINGLE_NEWS, getDetailedNews);
    yield takeLatest(GET_MOST_READ_NEWS_BY_CATEGORY, getMostReadNewsCategory);
    yield takeLatest(DELETE_NEWS, deleteNewsFlow);
    yield takeLatest(MOST_READ_NEWS, mostReadNewsFlow);
}
